import type { SpatialFilterRelation } from 'cadenza/workbook/conditions/spatial-condition/model/spatial-filter-relation.gen';
import type { WorkbookSpatialConditionValueItemDto } from 'cadenza/workbook/model/condition-dto';
import type { ConditionId } from 'cadenza/workbook/model/condition-id.gen';

/**
 * Opens the dialog to create or edit spatial condition
 */
export async function openEditSpatialConditionModal({
  conditionId,
  spatialConditionRelation,
  spatialConditionValues,
}: {
  conditionId?: ConditionId;
  spatialConditionRelation?: SpatialFilterRelation;
  spatialConditionValues?: WorkbookSpatialConditionValueItemDto;
} = {}) {
  const { SpatialConditionModal } = await import(
    'cadenza/workbook/conditions/spatial-condition/spatial-condition-modal'
  );
  await new SpatialConditionModal(conditionId, spatialConditionRelation, spatialConditionValues).connectAndShow();
}
